import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M11.998 6.78v.016c0 .704-.246 1.48-.648 2.27-.4.788-.94 1.557-1.49 2.238a21 21 0 0 1-1.858 2.015q-.15-.142-.35-.341a21 21 0 0 1-1.51-1.674c-.55-.681-1.09-1.45-1.49-2.237-.404-.791-.65-1.568-.65-2.271v-.017a4.3 4.3 0 0 1 .267-1.631 4.2 4.2 0 0 1 .86-1.391c.374-.399.821-.715 1.314-.93a3.88 3.88 0 0 1 3.114 0c.493.215.94.531 1.313.93.374.398.667.871.861 1.39.194.52.285 1.075.267 1.632"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8 8.193a1.548 1.548 0 1 0 0-3.096 1.548 1.548 0 0 0 0 3.096"
    }, null, -1)
  ]))]))
}
export default { render: render }